export default __webpack_public_path__ + "locales/bg/InfoPanel.json?hash=9712d3bc3ac700be9417a2e4d528d24c";